import styles from "src/components/organisms/ReferalInfo/styles.module.css";
import Avatar from "src/assets/images/avatar.svg";
import { Button } from "src/components/atoms/Button";
import { Input } from "src/components/atoms/Input";
import { Msg, msg } from "src/i18n/Msg";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { Modal } from "src/components/organisms/Modal";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import { useGetPromoCode } from "src/queries/useGetPromoCode";

export const ReferalInfo = () => {
  const intl = useIntl();
  const { data } = useGetPromoCode();
  const [promoCode, setPromoCode] = useState("");
  // Подтверждение копирования — явное модальное окно (portal, поверх контента).
  // toast здесь не показывался: несколько ToastContainer без containerId в приложении
  // конфликтуют, и уведомление уходило не в тот/невидимый контейнер.
  const [copyModal, setCopyModal] = useState<"success" | "error" | null>(null);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(promoCode);
      } else {
        // Fallback для мобильных WebView (в т.ч. Telegram), где Clipboard API
        // недоступен: копируем через временный textarea + execCommand.
        const ta = document.createElement("textarea");
        ta.value = promoCode;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopyModal("success");
    } catch {
      setCopyModal("error");
    }
  };
  const user = useSelector((state: RootState) => state.profile.user);
  useEffect(() => {
    setPromoCode(data?.data?.promo_code ?? "");
  }, [data]);

  return (
    <div className={styles.profile}>
      <div className={styles.wrapperImg}>
        <div className={styles.img}>
          <img src={user?.profile_picture ?? Avatar} alt="avatar" />
        </div>
        <div className={styles.inputs}>
          <Input
            value={promoCode}
            placeholder={msg(intl, {
              id: "components.organisms.ReferalInfo.promocode.placeholder",
            })}
            onChange={(e) => setPromoCode(e.target.value)}
            label={{ id: "components.organisms.ReferalInfo.promocode" }}
          />
          <Button
            onClick={handleCopy}
            text={{ id: "components.organisms.ReferalInfo.btn" }}
          />
        </div>
      </div>
      <div className={styles.description}>
        <h5>
          <Msg id="components.organisms.ReferalInfo.title" />
        </h5>
        <p>
          <Msg id="components.organisms.ReferalInfo.text" />
        </p>
        <p>
          <Msg id="components.organisms.ReferalInfo.textInfo" />
        </p>{" "}
      </div>
      <Modal
        isVisible={copyModal !== null}
        closeModal={() => setCopyModal(null)}
        isShowClose
        className={styles.copyModal}
      >
        <h3 className={styles.copyModalTitle}>
          <Msg
            id={
              copyModal === "error"
                ? "components.organisms.ReferalInfo.copy.error"
                : "components.organisms.ReferalInfo.copy.success"
            }
          />
        </h3>
      </Modal>
    </div>
  );
};
